import { useState } from 'react'
import { Pagination, PaginationItem } from '@mui/material'
import { noop } from 'lodash'
import './ListPager.scss'

/**
 * @typedef {object} ListPagerProps
 * @property {number} numPages
 * @property {number=} pageIndex
 * @property {function=} onChange
 */

/**
 * @param {ListPagerProps} props
 * @return {JSX.Element}
 */
const ListPager = ({ numPages = 0, pageIndex = 0, onChange = noop }) => {
  const [currentPage, setCurrentPage] = useState(pageIndex + 1)
  /**
   * @param {any} _
   * @param {number} page
   */
  const handleChange = (_, page) => {
    setCurrentPage(page)
    onChange(page - 1)
  }

  return (
    <Pagination
      count={numPages}
      color="primary"
      siblingCount={2}
      page={currentPage}
      onChange={handleChange}
      classes={{
        ul: 'list-pager',
      }}
      renderItem={(item) => (
        <PaginationItem
          classes={{
            root: 'list-pager__item',
            page: 'list-pager__page',
            previousNext: `${
              item.type === 'previous'
                ? 'list-pager__prev'
                : item.type === 'next'
                ? 'list-pager__next'
                : ''
            }`,
            ellipsis: 'list-pager__ellipsis',
            selected: 'list-pager__selected',
            disabled: 'list-pager__disabled',
          }}
          {...item}
        />
      )}
    />
  )
}

export default ListPager
